import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

const PaginationBarWrapper = styled(Box)`
   
`;

export default PaginationBarWrapper;
